<button
  type="button"
  nbButton
  size="large"
  shape="round"
  ghost
  class="cart-button-unified"
  [attr.aria-label]="
    (totalCount$ | async)
      ? 'Open cart, ' + (totalCount$ | async) + ((totalCount$ | async) === 1 ? ' item' : ' items')
      : 'Open cart, empty'
  "
  (click)="openDrawer()"
>
  Cart
  <nb-icon icon="shopping-cart-outline"></nb-icon>
  <nb-badge
    [text]="(totalCount$ | async) ?? 0"
    position="top right"
    [ngClass]="{ pulse: (totalCount$ | async) }"
    status="success"
  >
  </nb-badge>
</button>
